
import Vue from 'vue'
import RPHFilterTabs from 'rph/molecules/RPHFilterTabs/index.vue'

import { IMenuObject } from 'types/DTO/menu'

const categoryList = {
  Информация: 'info',
  Покупателю: 'buyer',
  Партнеру: 'partner',
  Документы: 'docs',
} as { [key: string]: string }

export default Vue.extend({
  name: 'RPHAbout',
  components: {
    RPHFaqAsideSelect: () => import('rph/organisms/RPHFaqAsideSelect/index.vue'),
    RPHFilterTabs,
  },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentTab: 'info',
      tabs: [
        {
          id: 1,
          title: 'Информация',
          value: 'info',
        },
        {
          id: 2,
          title: 'Покупателю',
          value: 'buyer',
        },
        {
          id: 3,
          title: 'Документы',
          value: 'docs',
        },
        {
          id: 4,
          title: 'Партнеру',
          value: 'partner',
        },
      ],
    }
  },
  computed: {
    item() {
      return this.$store.getters['rph-content/content']
    },
    /* Remove &nbsp for content */
    textFormat(): string {
      return this.$services.common.textFormat.formatText(this.item?.attributes.text ?? '')
    },
    menuAbout(): IMenuObject[] {
      return this.$store.getters['rph-menu/menuAbout']
    },
  },
  mounted() {
    this.currentTab = categoryList[this.category?.category] || 'info'
  },
  methods: {
    setTab(tab: string): void {
      this.currentTab = tab
    },
  },
})
